import React from "react";

// Local
import { Content } from "../styled/styled";

const Intro = () => {
  return (
    <Content>
      <p>
        For centuries, tribes, states and nations have waged war with one
        another in quest of resources, sovereignty and power.
      </p>
      <p>
        But states and nations have also forged alliances to cooperate, avoid
        conflicts and achieve common goals. International organizations exist to
        promote peace and to serve as a hub for solving problems in the areas of
        economic, cultural, environmental or social developments.
      </p>
      <p>
        Despite sharing common goals, not all countries belong to the same
        organizations. The interests and ideologies that motivated the creation
        of international organizations are not always the same.
      </p>
    </Content>
  );
};

export default Intro;
